import { c as _c } from "react/compiler-runtime";
import { ArchiveTwoToneIcon } from "@components/common/icons";
import { EmptyPage } from "@src/components/common/empty-page/empty-page";
import { ProjectsDuoIcon, SearchDuoIcon } from "@flat-ui";
import { UtilsTypes } from "@stellar/utils";
/** Empty page content for projects overview */
export function ProjectsOverviewEmptyPage(t0) {
  const $ = _c(6);
  const {
    projectArchivingState,
    isSearching,
    isFiltering: t1
  } = t0;
  const isFiltering = t1 === undefined ? false : t1;
  if (isFiltering) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title="No results found" subtitle="There are no projects that match the filters." icon={SearchDuoIcon} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (isSearching) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title="No results found" subtitle="There are no projects that match this search." icon={SearchDuoIcon} />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (projectArchivingState === UtilsTypes.ProjectArchivingState.archived) {
    const t2 = `No ${projectArchivingState} projects`;
    let t3;
    if ($[2] !== t2) {
      t3 = <EmptyPage title={t2} subtitle="When you archive a project it will be stored here and remain in your workspace." icon={ArchiveTwoToneIcon} />;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t2 = `No ${projectArchivingState} projects`;
  let t3;
  if ($[4] !== t2) {
    t3 = <EmptyPage title={t2} subtitle="You don't have any active projects in your workspace. Create a new project or unarchive one of the projects in the archived tab." icon={ProjectsDuoIcon} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}